const WidgetLoader = (props) => {
  return (
    <div style={{width: '100%', height: '20px'}} className="text-center">
          <span className="fa fa-spinner fa-spin fa-fw ms-3 fa-3x"></span>
    </div>
  );
};
export default WidgetLoader;